import React from 'react'
import '../assets/sass/errorPage.scss'
import { useHistory } from 'react-router-dom'
function InternalErrorPage() {

  const history = useHistory()

  return (
    <div className="error-page">
      <div className="error-container">
        <img src="https://i.imgur.com/qIufhof.png" alt="error-page" />

        <h1>
          <span>500</span> <br />
          Internal server error
        </h1>
        <p>We are currently trying to fix the problem.</p>
        <button onClick={e => history.goBack()} className="btn btn-outline-primary">Return Back</button>
      </div>
    </div>
  )
}

export default InternalErrorPage
